<template>
    <Modal :value="visible" :width="1000" footer-hide @on-visible-change="$emit('update:visible', $event)"
        :title="form.chineseName || '书籍详情'">
        <Form v-if="visible" :model="form" label-position="left" ref="formRef" :label-width="70" label-colon>
            <Row :gutter="24">
                <Col :span="8">
                <Row>
                    <Col :span="24">
                    <img :src="form.fileUrl" style="width: 100%;height:409px;" />
                    </Col>
                    <Col :span="24">
                    <FormItem :label-width="0">
                        <span>
                            {{ form.novelDesc }}
                        </span>
                    </FormItem>
                    </Col>
                </Row>
                </Col>
                <Col :span="16">
                <div style="display: flex; align-items: center;font-size: 24px;color:#000">
                    <span class="material-symbols-outlined import_contacts" style="font-size:30px;margin-right: 10px">
                        import_contacts </span>
                    书籍信息
                </div>
                <Divider style="margin: 10px 0" />
                <Row :gutter="24">
                    <Col :span="24">
                    <FormItem label="书籍ID">
                        <span style="color:#2db7f5">{{ form.id }}</span>
                    </FormItem>
                    </Col>
                    <Col :span="24">
                    <FormItem label="内部书名">
                        {{ form.chineseName }}
                    </FormItem>
                    </Col>
                    <Col :span="24">
                    <FormItem label="展示名称">
                        <span>{{ form.novelName }}</span>
                    </FormItem>
                    </Col>
                    <Col :span="24">
                    <FormItem label="标签">
                        <div style="display: flex;overflow:hidden;min-height: 1rem;">
                            <span v-for="(item,index) in form.tags||[]" :key="index" :style="{
                                ...tagColor(index),
                                padding: '5px 10px'
                            }">{{ item }}</span>
                        </div>
                    </FormItem>
                    </Col>
                    </Row>
                    <Row :gutter="24">
                    <Col :span="8">
                    <FormItem label="作者">
                        {{ form.novelAuthor }}
                    </FormItem>
                    </Col>
                    <Col :span="8">
                    <FormItem label="频道">
                        <span style="display: inline-block;min-height: 1rem">{{ form.channelName }}</span>
                    </FormItem>
                    </Col>
                    </Row>
                    <Row :gutter="24">
                    <Col :span="8">
                    <FormItem label="一级分类">
                        <span style="display: inline-block;min-height: 1rem">{{ form.primaryCategoryName }}</span>
                    </FormItem>
                    </Col>
                    <Col :span="8">
                    <FormItem label="二级分类">
                        <span style="display: inline-block;min-height: 1rem">{{ form.secondaryCategoryName }}</span>
                    </FormItem>
                    </Col>
                    <Col :span="8">
                    <FormItem label="章节数">
                        <span style="color:#2db7f5">{{ form.novelTotal }}</span>
                    </FormItem>
                    </Col>
                    </Row>
                    <Row :gutter="24">
                    <Col :span="8">
                    <FormItem label="付费章节">
                        <span>Chapter {{ form.paidChapters }}</span>
                    </FormItem> 
                    </Col>
                    <Col :span="8">
                    <FormItem label="连载状态">
                        <span>{{ form.novelStatusName }}</span>
                    </FormItem>
                    </Col>
                    </Row>
                    <Row :gutter="24">
                    <Col :span="8">
                    <FormItem label="创建时间">
                        <span>{{ form.createTime }}</span>
                    </FormItem>
                    </Col>
                    <Col :span="8">
                    <FormItem label="更新时间">
                        <span>{{ form.updateTime }}</span>
                    </FormItem>
                    </Col>
                    </Row>
                    
                
                <Divider style="margin-top: 0;" />
                    <Button type="info" @click="handleOpenChapter">进入章节管理</Button>
                </Col>

            </Row>
        </Form>
        <Chapters v-model="chapterVisible" :form="form" />
    </Modal>
</template>

<script>
import { getTagList } from '@/api/tag'
import Chapters from './chapters.vue'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        form: {
            type: Object,
            default: () => ({})
        },
        dictionary: {
            type: Object,
            default: () => ({})
        }
    },
    model: {
        prop: 'visible',
        event: 'update:visible'
    },
    components:{
        Chapters
    },
    data() {
        return {
            chapterVisible: false,
            tagList: [],
        }
    },
    methods: {
        tagColor(index){
            const colorLi = ['#075985', '#115e59', '#3730a3', '#6b21a8', '#9f1239']
            const backGoundColorLi = ['#e0f2fe', '#ccfbf1', '#e0e7ff', '#f3e8ff', '#ffe4e6']
            return {
                backgroundColor: backGoundColorLi[index % 5],
                color: colorLi[index % 5],
                margin: '5px 10px 0 0',
                borderRadius: '50px',
                fontSize: '15px',
                whiteSpace: 'nowrap',
                lineHeight: '13px',
                height: '20px'
            }
        },
        handleGetTagList() {
            getTagList({
                current: 1,
                size: 10000
            }).then(r => {
                this.tagList = r.data.records
            })
        },
        handleOpenChapter(){
            this.chapterVisible = true
        }
    },
    mounted() {
        this.handleGetTagList()
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-form-item {
    &>label {
        font-size: 12px
    }

    &>.ivu-form-item-content {
        color: #000;
        font-size: 14px;
    }

    margin-bottom: 7px !important;
}
</style>